import { render, staticRenderFns } from "./MPopupAccountPayDetail.vue?vue&type=template&id=4ef50908&"
import script from "./MPopupAccountPayDetail.vue?vue&type=script&lang=ts&"
export * from "./MPopupAccountPayDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports